import { r as registerInstance, c as createEvent, h, g as getElement } from './index-c269755a.js';
import { T as TabNavigationTypes } from './TabNavigation-5195f8a6.js';

const teliaTabCss = ".telia-tab__header{list-style:none;margin:calc(0.4rem * var(--voca-rem-multiplier)) calc(0.2rem * var(--voca-rem-multiplier)) calc(0.4rem * var(--voca-rem-multiplier)) calc(0.2rem * var(--voca-rem-multiplier))}.telia-tab__header:last-child{margin-right:calc(0.4rem * var(--voca-rem-multiplier))}.telia-tab__header--active{background-color:#ffffff;margin-bottom:0}.telia-tab__wrapper{position:relative;}@media (any-pointer: coarse){.telia-tab__wrapper{-ms-overflow-style:none;}.telia-tab__wrapper ::-webkit-scrollbar{display:none;}}.telia-tab__wrapper--has-scroll .telia-tab__list{overflow-y:auto}.telia-tab__wrapper--is-scrolled{-webkit-mask-image:linear-gradient(to left, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)));mask-image:linear-gradient(to left, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)))}.telia-tab__wrapper--is-scrolled .telia-tab__list{-webkit-mask-image:linear-gradient(to right, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)));mask-image:linear-gradient(to right, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)))}.telia-tab__wrapper--scroll_end{-webkit-mask-image:none;mask-image:none}.telia-tab__wrapper--scroll_end .telia-tab__list{-webkit-mask-image:linear-gradient(to right, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)));mask-image:linear-gradient(to right, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)))}.telia-tab__wrapper--scroll_start{-webkit-mask-image:linear-gradient(to left, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)));mask-image:linear-gradient(to left, rgba(0, 0, 0, 0) 0, black calc(5.9rem * var(--voca-rem-multiplier)))}.telia-tab__list{display:inline-flex;max-width:100%;min-width:100%;overflow-y:visible;position:relative}@media (any-pointer: coarse){.telia-tab__list{overflow:hidden}}.telia-tab__list::before{content:\"small\";display:none}@media screen and (min-width: 37.5em){.telia-tab__list::before{content:\"medium\"}}@media screen and (min-width: 64em){.telia-tab__list::before{content:\"large\"}}.telia-tab__list__container{display:inline-flex;flex-grow:1;margin:0 0 0 calc(-1 * calc(0.2rem * var(--voca-rem-multiplier)));padding:0}@media (any-pointer: coarse){.telia-tab__list__container{overflow-x:scroll;overflow-y:hidden;scrollbar-width:none;}}.telia-tab__content{background-color:#ffffff;padding:calc(1.6rem * var(--voca-rem-multiplier)) 0}.telia-tab__content--light-background{background-color:#ffffff}.telia-tab__content .telia-tab__container{padding:0 calc(1.6rem * var(--voca-rem-multiplier))}@media screen and (min-width: 37.5em){.telia-tab__content .telia-tab__container{padding:0 calc(2.4rem * var(--voca-rem-multiplier))}}@media screen and (min-width: 64em){.telia-tab__content .telia-tab__container{padding:0 calc(2.4rem * var(--voca-rem-multiplier))}}.telia-tab--default .telia-tab__container{box-sizing:border-box;display:block;margin-left:auto;margin-right:auto;max-width:calc(144rem * var(--voca-rem-multiplier));padding:0 calc(1.6rem * var(--voca-rem-multiplier));width:100%}@media screen and (min-width: 37.5em){.telia-tab--default .telia-tab__container{padding:0 calc(2.4rem * var(--voca-rem-multiplier))}}@media screen and (min-width: 64em){.telia-tab--default .telia-tab__container{padding:0 calc(4.8rem * var(--voca-rem-multiplier))}}@media screen and (min-width: 90em){.telia-tab--default .telia-tab__container{padding:0 calc(6.4rem * var(--voca-rem-multiplier))}}.telia-tab--default .telia-tab__wrapper--has-scroll{margin-left:calc(-1 * calc(1.6rem * var(--voca-rem-multiplier)));margin-right:calc(-1 * calc(1.6rem * var(--voca-rem-multiplier)));}@media screen and (min-width: 37.5em){.telia-tab--default .telia-tab__wrapper--has-scroll{margin-left:calc(-1 * calc(2.4rem * var(--voca-rem-multiplier)));margin-right:calc(-1 * calc(2.4rem * var(--voca-rem-multiplier)))}}@media screen and (min-width: 64em){.telia-tab--default .telia-tab__wrapper--has-scroll{margin-left:calc(-1 * calc(4.8rem * var(--voca-rem-multiplier)));margin-right:calc(-1 * calc(4.8rem * var(--voca-rem-multiplier)))}}.telia-tab--default .telia-tab__wrapper--has-scroll .telia-tab__header:first-child{margin-left:calc(1.6rem * var(--voca-rem-multiplier))}@media screen and (min-width: 37.5em){.telia-tab--default .telia-tab__wrapper--has-scroll .telia-tab__header:first-child{margin-left:calc(2.4rem * var(--voca-rem-multiplier))}}@media screen and (min-width: 64em){.telia-tab--default .telia-tab__wrapper--has-scroll .telia-tab__header:first-child{margin-left:calc(4.8rem * var(--voca-rem-multiplier))}}.telia-tab--light .telia-tab__list,.telia-tab--light-wide .telia-tab__list{position:static;width:100%}.telia-tab--light .telia-tab__list::after,.telia-tab--light-wide .telia-tab__list::after{background-color:#c8c8cd;bottom:calc(0.2rem * var(--voca-rem-multiplier));content:\"\";display:block;height:calc(0.2rem * var(--voca-rem-multiplier));left:0;position:absolute;right:0;width:100%}.telia-tab--light .telia-tab__header--active,.telia-tab--light-wide .telia-tab__header--active{background-color:transparent}.telia-tab--light .telia-tab__content,.telia-tab--light-wide .telia-tab__content{background-color:transparent}.telia-tab--wide .telia-tab__header,.telia-tab--light-wide .telia-tab__header{flex-basis:auto;flex-grow:1;min-width:fit-content;width:calc(17.7rem * var(--voca-rem-multiplier))}@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}";

const TeliaTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.vocaTabChange = createEvent(this, "vocaTabChange", 7);
    /** State scroll used for toggeling horizontal scroll shadow */
    this.scrollClasses = ' ';
    /** Array of slotted children */
    this.children = [];
    /** sets background on content */
    this.background = false;
    /** variant */
    this.variant = 'default';
    /** Tracking id is used to identify and count Component usage */
    this.dataTrackingId = 'telia-tab';
    this.activeIndex = 0;
    this.wrapperClass = 'telia-tab__wrapper';
    this.isKeyPress = true;
    /**
     * Because the component effectively reloads directly after
     * first load, we need to scroll to the active tab in the componentDidUpdate
     * hook. This can create an infinite loop unless prevented by this property
     * that is set to true when/if user scrolls.
     */
    this.preventScrollLoop = false;
    this.onIntersection = (entries) => {
      // If all entries are visible
      if (entries.every(entry => entry.isIntersecting)) {
        this.scrollClasses = ' ';
      }
      entries.forEach(entry => {
        // if entry is visible
        if (entry.isIntersecting) {
          let entryIndex = Number(entry.target.children[0].getAttribute('data-index'));
          if (entryIndex === 0 || entryIndex === 1) {
            this.scrollClasses =
              this.wrapperClass +
                '--scroll_start' +
                ' ' +
                this.wrapperClass +
                '--has-scroll';
          }
          else if (entryIndex === this.tabItems.length - 1) {
            this.scrollClasses =
              this.wrapperClass +
                '--scroll_end' +
                ' ' +
                this.wrapperClass +
                '--has-scroll';
          }
          else if (this.scrollClasses !=
            this.wrapperClass +
              '--is-scrolled' +
              ' ' +
              this.wrapperClass +
              '--has-scroll') {
            this.scrollClasses =
              this.wrapperClass +
                '--is-scrolled' +
                ' ' +
                this.wrapperClass +
                '--has-scroll';
          }
        }
      });
    };
  }
  handleTabNavigation(e) {
    const { location, key } = e.detail.value;
    const currentIndex = this.activeIndex;
    let nextIndex;
    this.isKeyPress = true;
    if (location > -1) {
      nextIndex = location;
      this.isKeyPress = false;
    }
    switch (key) {
      case TabNavigationTypes.ArrowLeft:
        if (currentIndex > 0) {
          nextIndex = currentIndex - 1;
        }
        else {
          nextIndex = this.children.length - 1;
        }
        break;
      case TabNavigationTypes.ArrowRight:
        if (currentIndex < this.children.length - 1) {
          nextIndex = currentIndex + 1;
        }
        else {
          nextIndex = 0;
        }
        break;
      case TabNavigationTypes.Home:
        nextIndex = 0;
        break;
      case TabNavigationTypes.End:
        nextIndex = this.children.length - 1;
        break;
    }
    this.activeIndex = nextIndex;
    this.children.forEach((child, index) => {
      child.active = index === nextIndex;
    });
    this.vocaTabChange.emit({ value: this.children[this.activeIndex].tabId });
    this.createChildren();
  }
  handleResize() {
    this.setBreakpointAndGridPadding();
    this.calculateScroll();
  }
  componentWillLoad() {
    this.createChildren();
    this.findPreSelectedTab();
  }
  componentDidLoad() {
    this.tabItems = this.host.shadowRoot.querySelectorAll('.telia-tab__header');
    this.observer = new IntersectionObserver(this.onIntersection, {
      threshold: [0.75],
    });
    this.tabItems.forEach(el => this.observer.observe(el));
    this.setGridPadding();
    this.setBreakpointAndGridPadding();
    this.calculateScroll();
  }
  componentDidUpdate() {
    if (!this.preventScrollLoop) {
      this.scrollToTarget(this.getActiveTabListItem());
    }
  }
  disconnectedCallback() {
    // if we have an intersection observer, disconnect it
    if (this.observer !== null) {
      this.observer.disconnect();
    }
  }
  /**
   * Gets and sets current grid padding, used for calculation of scroll
   * @private
   */
  setGridPadding() {
    if (this.variant != 'default') {
      // 4 = the left margin on the first tab-header + the right margin on the last tab-header
      this.gridPadding = 4;
      return;
    }
    const tabContent = this.host.shadowRoot.querySelector('.telia-tab__content .telia-tab__container');
    this.gridPadding = parseInt(window.getComputedStyle(tabContent).getPropertyValue('padding-left'));
  }
  /**
   * Get current breakpoint from style. It is important to
   * call calculateScroll after this method is called,
   * or it may not have desired effect.
   * @private
   */
  setBreakpointAndGridPadding() {
    if (this.tabList === undefined) {
      return;
    }
    const currentBreakpoint = window
      .getComputedStyle(this.tabList, ':before')
      .getPropertyValue('content')
      .replace(/\"/g, '');
    if (currentBreakpoint != this.breakPoint) {
      this.breakPoint = currentBreakpoint;
      this.setGridPadding();
    }
  }
  /**
   * Check if there is a pre-selected tab,
   * else set first tab as pre-selected
   * @private
   */
  findPreSelectedTab() {
    if (this.children.length === 0)
      return;
    /**
     * flag to indicate that an active tab
     * was found on render
     */
    let activePreSet = false;
    this.children.forEach((child, index) => {
      if (activePreSet) {
        /**
         * since flag is true
         * all other tabs should
         * be set to not active
         */
        child.active = false;
      }
      if (child.active) {
        activePreSet = true;
        this.activeIndex = index;
      }
    });
    if (this.activeIndex === 0) {
      this.children[this.activeIndex].active = true;
    }
  }
  /**
   * Will scroll tab list to keyboard focused tab header
   * @param target
   * @private
   */
  scrollToTarget(target) {
    var _a;
    /**
     * scroll may not be available in
     * test runner, so check existence
     * before proceeding.
     */
    if (this.tabList.scroll == null) {
      return;
    }
    const targetRect = target.getBoundingClientRect();
    const wrapperRect = this.tabList.getBoundingClientRect();
    const wrapperWidth = this.tabList.clientWidth;
    const wrapperOffset = parseInt((_a = getComputedStyle(this.tabList)['border-width-left']) === null || _a === void 0 ? void 0 : _a.split('px')[0], 10);
    let offset = wrapperRect.left + (isNaN(wrapperOffset) ? 0 : wrapperOffset);
    let left;
    //Handle forward navigation
    if (targetRect.right > wrapperRect.right) {
      left = targetRect.left + this.tabList.scrollLeft;
      left = left + targetRect.width - wrapperWidth + wrapperWidth * 0.1;
      left = left - offset;
    }
    //Handle backwards navigation
    if (targetRect.left < wrapperRect.left) {
      left = targetRect.left + this.tabList.scrollLeft;
      left = left - wrapperWidth * 0.1;
      left = left - offset;
    }
    if (left !== undefined) {
      this.tabList.scroll({ left: left, behavior: 'smooth' });
    }
  }
  /**
   * Create child array
   * @private
   */
  createChildren() {
    this.children = [];
    let slotted = this.host.querySelectorAll('telia-tab-content');
    slotted.forEach(node => {
      if (node.nodeName.indexOf('TELIA-TAB') > -1) {
        this.children.push(node);
      }
    });
  }
  getActiveTabListItem() {
    return this.tabList.querySelector('.telia-tab__header--active');
  }
  /**
   * Checks if there is a scroll in tab list and sets relevant class
   * @private
   */
  calculateScroll() {
    this.scrollToTarget(this.getActiveTabListItem());
    let headerContainer = this.host.shadowRoot.querySelector('.telia-tab__list__container');
    let headerWrapper = this.host.shadowRoot.querySelector('.telia-tab__wrapper');
    if (headerContainer.scrollWidth >
      headerWrapper.offsetWidth + this.gridPadding) {
      this.scrollClasses =
        this.wrapperClass +
          '--scroll_start ' +
          this.wrapperClass +
          '--has-scroll';
    }
    else if (headerContainer.scrollWidth < headerWrapper.offsetWidth) {
      this.scrollClasses = ' ';
    }
  }
  render() {
    const tabClasses = {
      'telia-tab': true,
      [`telia-tab--${this.variant}`]: !!this.variant,
    };
    const contentClasses = {
      'telia-tab__content': true,
      'telia-tab__content--light-background': this.background,
    };
    return (h("div", { class: tabClasses }, h("telia-vst", { dataTrackingId: this.dataTrackingId }), h("div", { class: "telia-tab__container" }, h("div", { class: this.wrapperClass + ' ' + this.scrollClasses }, h("div", { ref: el => (this.tabList = el), class: "telia-tab__list", role: "tablist" }, h("ul", { class: "telia-tab__list__container", role: "presentation" }, this.children.map((child, index) => {
      return (h("li", { role: "presentation", class: {
          'telia-tab__header': true,
          'telia-tab__header--active': child.active,
        }, onFocusin: e => {
          this.scrollToTarget(e.target);
        } }, h("telia-tab-header", { tabId: child.tabId, icon: child.icon, name: child.name, active: child.active, "data-testid": child.dataTestid, "data-index": index, "is-key-press": this.isKeyPress, variant: this.variant }, child.name)));
    }))))), h("div", { class: contentClasses, role: "presentation" }, h("div", { class: "telia-tab__container", role: "presentation" }, h("slot", null)))));
  }
  get host() { return getElement(this); }
};
TeliaTab.style = teliaTabCss;

export { TeliaTab as telia_tab };
